<template>
  <div style="width: 100%">
    <v-text-field v-model="user_query" outlined flat dense clearable hide-details dark
      label="What notices are you looking for?" prepend-inner-icon="mdi-creation" class="mx-auto font-regular"
      :loading="loading_query" @keyup.enter="plainTextSearch">
      <template v-slot:loader>
        <v-progress-linear v-if="loading_query" color="primary" height="7" indeterminate></v-progress-linear>
      </template>
    </v-text-field>
    <v-snackbar v-model="errorToast" color="warning">
      Tracey couldn't understand your request. Please be more specific.
      <template v-slot:actions>
        <v-btn color="primary" variant="text" @click="errorToast = false">Close</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { fetchAIQueries, fetchSearchQuery } from "./APIManager.js";

export default {
  props: {
    runSearch: Number,
  },

  data() {
    return {
      freeText: "",
      loading_query: false,
      user_query: "",
      userHistory: [],
      loadingHistory: false,
      errorToast: false,
    };
  },

  mounted() {
  },

  watch: {
    runSearch(newVal) {
      // Trigger search when `runSearch` prop changes
      this.plainTextSearch();
    },

  },

  methods: {
    async getAIQueries() {
      this.loadingHistory = true;
      try {
        const response = await fetchAIQueries();
        this.userHistory = response.data;
      } catch (error) {
        this.isError = true;
      } finally {
        this.loadingHistory = false;
      }
    },

    plainTextSearch() {
      // Verify the current value of `user_query`
      //console.log("plainTextSearch - USER QUERY:", this.user_query);

      // Ensure `user_query` is non-empty before executing search
      this.loading_query = true;
      this.errorToast = false;
      fetchSearchQuery(this.user_query, this.formatDateToCustomString(new Date()))
        .then((response) => {
          //console.log(response);
          const query = JSON.parse(response.query);
          this.$router.push({ path: "/search", query: query });
          //this.viewQueryResults(response.querystring);

          this.user_query = ""; // Clear the input after search
        })
        .catch(() => {
          this.errorToast = true;
        })
        .finally(() => {
          this.loading_query = false;
        });
    },

    formatDateToCustomString(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");
      const milliseconds = String(date.getMilliseconds()).padStart(3, "0");

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds}`;
    },

    formattedTimestamp(timestamp) {
      const optionsTime = { hour: "numeric", minute: "numeric", hour12: true };
      const optionsDate = { year: "numeric", month: "short", day: "numeric" };
      return (
        new Date(timestamp).toLocaleTimeString(undefined, optionsTime) +
        ", " +
        new Date(timestamp).toLocaleDateString(undefined, optionsDate)
      );
    },
  },
};
</script>

<style>
.menu-item-text {
  font-size: 13px;
}

.created-date {
  font-size: 10px;
  color: #888;
}
</style>
